// extracted by mini-css-extract-plugin
export var homeHero = "PageDataBodyHomeHero-module--homeHero--PTlRp";
export var homeHeroHeadings = "PageDataBodyHomeHero-module--homeHeroHeadings--c1BiE";
export var homeHeroMedia = "PageDataBodyHomeHero-module--homeHeroMedia--3cOor";